module.exports = __webpack_public_path__ + "static/img/img-cp6.56bb736.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp6.png
// module id = G93S
// module chunks = 0